﻿import React from 'react';
import AboutPageContent from '../sections/AboutPageContent';

export const AboutPage: React.FC = () => {
  return (
    <main className="about-page-root" style={{ paddingTop: '0px' }}>
      <AboutPageContent preview={false} />
    </main>
  );
};

export default AboutPage;

